import { FC, useCallback, useRef, useState } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectPatientAudioCallStatus } from 'store/call/selectors';

import {
  StyledAudioCall,
  StyledAudioCallVideo,
  StyledFullScreen
} from './styled';
import { AudioCallHeaderMethods } from './_types';
import MeetingAction from './MeetingAction';
import AudioRouteButton from './AudioRouteButton';
import CallHeader from './CallHeader';
import Draggable from './Draggable';
import MicrophoneButton from './MicrophoneButton';
import CameraButton from './CameraButton';
import { audioCallRemoteVideoRef } from './_refs';
import CallSound from './CallSound';

const AudioCall: FC = () => {
  const callHeaderRef = useRef<AudioCallHeaderMethods | null>(null);
  const selfVideoRef = useRef<HTMLVideoElement | null>(null);

  const status = useAppSelector(selectPatientAudioCallStatus);

  const [callerName] = useState('');
  const [isSelfVideoEnabled, setSelfVideoEnabled] = useState(false);
  const [isAudioEnabled, setAudioEnabled] = useState(true);
  const [isFullScreen, setFullScreen] = useState(true);

  const onEndCall = useCallback(() => {
    // TODO: removed to implement with twilio
  }, []);

  const toggleFullScreen = useCallback(() => {
    setFullScreen(prev => !prev);
  }, []);

  if (typeof status === 'undefined') {
    return null;
  }

  return (
    <Draggable isFullScreen={isFullScreen}>
      <StyledAudioCall $hasVideo={false}>
        <StyledFullScreen>
          <MeetingAction
            icon={isFullScreen ? 'fullscreenExit' : 'fullscreen'}
            onClick={toggleFullScreen}
          />
        </StyledFullScreen>
        <div className="audio-call-content">
          <StyledAudioCallVideo>
            <video
              ref={audioCallRemoteVideoRef}
              autoPlay
              playsInline
              muted={false}
              controls={false}
            />
          </StyledAudioCallVideo>
          {isSelfVideoEnabled && (
            <StyledAudioCallVideo $small={false}>
              <video
                ref={selfVideoRef}
                autoPlay
                playsInline
                muted
                controls={false}
              />
            </StyledAudioCallVideo>
          )}
          <CallHeader
            ref={callHeaderRef}
            callerName={callerName}
            status={status}
          />
        </div>
        <div className="audio-call-buttons">
          <CameraButton
            isEnabled={isSelfVideoEnabled}
            onChange={setSelfVideoEnabled}
            status={status}
          />
          <AudioRouteButton
            isVideoEnabled={isSelfVideoEnabled}
            isAudioEnabled={isAudioEnabled}
          />
          <MicrophoneButton
            isEnabled={isAudioEnabled}
            onChange={setAudioEnabled}
          />
          <MeetingAction isDecline icon="hang" onClick={onEndCall} />
        </div>
        <CallSound />
      </StyledAudioCall>
    </Draggable>
  );
};

export default AudioCall;
